<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
/* eslint-disable */
// import { mapMutations, mapGetters, mapActions } from 'vuex'

export default {
  name: 'initial',
  data () {
    return {
      brand: localStorage.getItem('brand'),
      color: '',
    }
  },
  mounted() {
    // console.log(this.$route.query.Auth);
    const root = document.documentElement; // 打通css - html
    // console.log(this.brand);
    if (this.brand === '') {
      root.style.setProperty('--main-color', '#F50');
    } else if (this.brand === 'Whittard') {
      root.style.setProperty('--main-color', '#51b0b5');
    } else if (this.brand === 'EdenPark') {
      root.style.setProperty('--main-color', '#000021');
    } else if (this.brand === 'JEEP') {
      root.style.setProperty('--main-color', '#000000');
    } else if (this.brand === 'NAUTICA') {
      root.style.setProperty('--main-color', '#001344');
    } else if (this.brand === 'LIP SERVICE') {
      root.style.setProperty('--main-color', '#000000');
    }
    // console.log(1);
  },
  // computed: {
  //   ...mapGetters({
  //     info: 'info',
  //   }),
  //   channelId: {
  //     get () { return this.info.clientId },
  //     set(value) { this.updateClientId({ clientId: value }); },
  //   },
  // },
  // methods: {
  //   ...mapMutations({
  //     updateClientId: 'updateClientId',
  //   }),
  // },
}

</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #222222;
  margin-top: 0px;
}
:root {
  --main-color: #369;
}
// .cube-scroll-nav_side > .cube-sticky > .cube-sticky-fixed {
//   width:38% !important;
//   height: 480px;
// }
.cube-scroll-nav-bar-item {
  width: 80px;
}
.cube-sticky-ele {
  height: 40px;
}
.cube-scroll-nav-panel-title {
  height: 30px;
  background-color: white;
}
.cube-tab_active {
  color: var(--main-color);
}
.cube-scroll-nav-bar-item_active {
  color: #51b0b5
}
.cube-tab-bar-slider {
  position: absolute;
  left: 0;
  bottom: 0;
  height: 2px;
  width: 20px;
  background-color: var(--main-color);
}
</style>
